import { useQuery } from 'react-query';

import { MatterKimThreadResponseDto } from '../../../../backend/src/matter/subset/kim/dto/matter-thread.dto';
import { APIBaseChronos } from '@/api/hosts';
import { ApiError, QueryEntity } from '@/api/types';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export const useGetMatterKimThreads = (matterId?: string, subsetId?: string, enabled = true) => {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<MatterKimThreadResponseDto[], ApiError>(
    [QueryEntity.MatterKimThreads, { matterId }],
    async () => {
      const res = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/kim/matter-threads`,
        fetchConfigGET,
      );
      if (!res.ok) {
        const error = await res.json();
        throw new ApiError(error.code, error.message);
      }
      return res.json();
    },
    {
      enabled: enabled && !!matterId && !!subsetId,
      refetchOnWindowFocus: false,
    },
  );
};
